import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import { Box, Skeleton } from '@mui/material';

const ActivitySkeleton = () => {
  const skeletonCount = 10;
  const dummyArray = Array.from({ length: skeletonCount }, (_, i) => i);

  return (
    <Timeline position="left">
      {dummyArray.map((item, index) => (
        <TimelineItem key={index} position="left">
          <TimelineOppositeContent
            align="right"
            variant="body2"
            color="text.secondary"
          >
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </TimelineOppositeContent>

          <TimelineSeparator>
            <TimelineDot color="grey" />
            {index < skeletonCount - 1 && <TimelineConnector />}
          </TimelineSeparator>

          <TimelineContent sx={{ py: '12px', px: 2 }} maxWidth="288px">
            <Box sx={{ mt: 1 }}>
              <Skeleton variant="text" width="40%" />
              <Skeleton variant="text" width="60%" />
            </Box>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
};

export default ActivitySkeleton;
